<div class="page-wrapper p-3">
  <div class="container-fluid">
    <form role="form" class="form-horizontal">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 mt-2">
          <!-- <div class="row hedin mt-2">
            <div class="col-md-3">State Name</div>
            <div class="col-md-4">College Name</div>
            <div class="col mb-1 text-center">Upload Letter</div>
            <div class="col mb-1 text-center">
              Tuition
              <div class="font-normal">(In/Out State)</div>
            </div>
            <div class="col-md-2 mb-1">Residency Selection</div>
          </div> -->
          <!--  -->

          <!-- <tui-loader [inheritColor]="true" [showLoader]="isLoading"> -->
          <div
            *ngFor="let list of selectedUniversityList; let i = index"
            class="fform-group mt-4 row border-bottom pt-2 pb-3"
          >
            <div [ngClass]="{ 'col-sm-5 col-row-main': true }">
              <div class="ml-2">
                <h4 class="col-nm d-flex align-items-center mb-0">
                  <img
                    *ngIf="list?.imageAvailable"
                    [src]="list?.collegeProfileIcon"
                  />
                  <!-- [ngClass]="AddHypen ? 'addhypen' : ''" -->
                  <span
                    *ngIf="list?.imageAvailable == false"
                    id="randomcolor"
                    [style.backgroundColor]="list?.defaultLabelColor"
                  >
                    {{ getFirstAndLastWords(list.name) }}
                  </span>
                  <!-- <img
                    [ngClass]="checkIconStatus(list?.collegeProfileIcon)"
                    [src]="list?.collegeProfileIcon"
                  /> -->
                  <!-- <img
                    src="https://cdn.virtueanalytics.com/cache/college-icon-top5.png"
                  /> -->
                  <span> {{ list?.name }} ({{ list?.stateCode }})</span>
                </h4>
                <div class="acc-rate">
                  <!-- <span >Acceptance Rate <strong>{{getAcceptanceRate1(list?.ipedsId,i)}} %</strong> -->
                  <span *ngIf="getAcceptanceRate1(list?.ipedsId, i)"
                    >Acceptance Rate
                    <strong>{{ getAcceptanceRate1(list?.ipedsId, i) }}%</strong>
                    <span
                      *ngIf="list?.control && list?.control != 'null'"
                      class="pl-2 pr-2 text-secondary"
                      >|</span
                    >
                  </span>
                  <span *ngIf="list?.control && list?.control != 'null'">
                    {{ getControlType(list?.control) }}

                    <span
                      class="pl-2 pr-2 text-secondary"
                      *ngIf="list?.hbcuCollege"
                      >|</span
                    >
                  </span>
                  <span *ngIf="list?.hbcuCollege"> HBCU </span>

                  <span *ngIf="list?.collegeRankInUS">
                    <span class="pl-2 pr-2 text-secondary">|</span>
                    Rank: <strong>{{ list?.collegeRankInUS }} </strong></span
                  >
                  <span *ngIf="checkIsReciprocityState(list.stateCode, i)">
                    <span class="pl-2 pr-2 text-secondary">|</span>
                  </span>
                  <span *ngIf="checkIsReciprocityState(list.stateCode, i)"
                    >Reciprocity Applied</span
                  >
                </div>
              </div>
            </div>

            <div class="col-sm-4 text-center m-last">
              <div class="awrdletter-tog">
                <div class="let">
                  <button
                    type="button"
                    class="custom-button"
                    *ngIf="showuploadButton[i]"
                  >
                    <fieldset disabled="disabled">
                      <span
                        *ngIf="
                          viewImgPdfArray[i] == undefined ||
                          viewImgPdfArray[i].length == 0
                        "
                        ><img
                          src="https://cdn.virtueanalytics.com/cache/award-letter-icon-top5.png"
                      /></span>
                    </fieldset>

                    <span *ngIf="viewImgPdfArray[i] != undefined">
                      <a
                        tooltip="View Award Letter"
                        (click)="openAwardLetter(viewImgPdfArray[i])"
                      >
                        <img src="assets/images/uploaded3.png" />
                      </a>
                    </span>
                  </button>
                </div>
                <div class="tog">
                  <div class="col text-center m-last">
                    <div *ngIf="showuploadButton[i]">
                      <fieldset disabled="disabled">
                        <label class="switch">
                          <input
                            type="checkbox"
                            [checked]="checkToggleInOutState(i)"
                          />
                          <!-- [checked]="checkToggleInOutState(i)" -->

                          <div class="slider">
                            <span class="in">In State</span>
                            <span class="out">Out State</span>
                          </div>
                        </label>
                      </fieldset>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-3 oncamp">
              <div *ngIf="showuploadButton[i]" class="disabled">
                <fieldset disabled="disabled">
                  <app-residency-selction-options
                    [pageAnswer]="interestPageAnswerMap"
                    [options]="getCampusOption(i)"
                    [index]="'r' + i"
                    [placeholder]="'Select Campus'"
                  >
                  </app-residency-selction-options>
                </fieldset>
              </div>
            </div>
            <div class="col-12 optionp">
              <div
                class="row affiinity-row mb-1 mt-5"
                *ngFor="
                  let ans of yearWiseAffinityQuestion[i];
                  let index = index
                "
              >
                <div class="head col-md-12">Affinity Questions</div>
                <div class="col-md-12 optionp">
                  <div class="row">
                    <div class="col-md-6 mb-2 mt-2">
                      <label
                        for="questions"
                        class="col-sm-12 control-label font-normal text-dark"
                        ><span>{{ ans.label }}</span></label
                      >
                      <div class="col-sm-6 in-option mt-1 ml-4">
                        <fieldset disabled="disabled">
                          <!-- <div class="form-check-inline"> -->
                          <app-checkboxoption
                            [pageAnswer]="interestPageAnswerMap"
                            [index]="'aq' + i + '-' + index"
                            [name]="i + '-' + index"
                            [options]="ans.options"
                            [Affinityindex]="index"
                            [Universityindex]="i"
                          >
                          </app-checkboxoption>
                        </fieldset>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="row affiinity-row mt-5"
                *ngFor="
                  let ans of selectedUniversityStateGrant[i];
                  let index = index
                "
              >
                <div class="head col-md-12">State Grant</div>
                <div
                  class="col-sm-12 col-md-12"
                  *ngIf="selectedUniversityStateGrant[i]"
                  class=""
                >
                  <div class="col-sm-12 in-option mt-2">
                    <div>
                      <div class="form-control ml-1 efc-cl">
                        <fieldset disabled="disabled">
                          <span>$</span>
                          <!-- <tui-input-number class="currency-input" [prefix]="''" [tuiTextfieldLabelOutside]="'true'"
                        [pseudoHovered]="'true'" [max]="999999999999999" [pseudoFocused]="'true'"
                        [(ngModel)]="stateGrantFieldValue[i]" >
                      </tui-input-number> -->
                          <input
                            type="text"
                            placeholder="State Grant"
                            [value]="addcommas(stateGrantFieldValue[i])"
                          />
                        </fieldset>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="row affiinity-row mt-5"
                *ngFor="
                  let ans of selectedUniversityCSSProfile[i];
                  let index = index
                "
              >
                <div class="head col-md-12">CSS Profile</div>
                <div
                  class="col-sm-12 col-md-12"
                  *ngIf="selectedUniversityList[i].usingCSSProfile"
                  class=""
                >
                  <span
                    [ngxTippy]="htmlTemplate"
                    [tippyProps]="templateRef"
                    class="text-success labeltoolTip-hover t-demo__btn col-md-12"
                  >
                    <label
                      for="questions"
                      class="control-label font-normal text-dark"
                      ><span>{{ ans.label }}</span></label
                    >
                  </span>
                  <template #htmlTemplate class="">
                    <div class="t-template" #tippyTemplatePassElement>
                      <p class="t-template__info text-left">
                        This college may use a CSS methodology for calculating
                        your SAI, this SAI may vary from the SAI calculated
                        using the federal methodology used by us. You can find
                        this SAI value by summing all contributions in your NPC
                        report,
                        <span
                          *ngIf="selectedUniversityList[i]?.importantLink?.npc"
                        >
                          or you can get a fresh calculation here :
                          <a
                            class="labeltoolTip-hover"
                            [href]="
                              selectedUniversityList[i]?.importantLink?.npc
                            "
                            target="_blank"
                            >{{
                              selectedUniversityList[i].importantLink.npc
                            }}</a
                          >
                        </span>
                      </p>
                    </div>
                  </template>
                </div>

                <div class="col-sm-12 in-option mt-2">
                  <div>
                    <div class="form-control ml-1 efc-cl">
                      <fieldset disabled="disabled">
                        <span>$</span>

                        <input
                          type="text"
                          placeholder="SAI"
                          [value]="addcommas(efcFieldValue[i])"
                        />
                      </fieldset>
                      <!-- <span *ngIf="!efcFieldValue[i]" class="profile-css"
                            >Please enter EFC.</span
                          > -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- </tui-loader> -->
        </div>
      </div>
    </form>
  </div>
</div>

<div class="align-page-bottom">
  <div class="text-center border-top pt-4">
    <button class="page-btn" (click)="next()">Next</button>
  </div>
</div>
